const to_array = require('to_array');

function LimitInputCharacters() {
  const inputs = to_array(document.querySelectorAll('[data-limit-characters]'));

  // Aplica a regra a todos os inputs com o atributo data-limit-characters
  inputs.forEach(input => {
    // Limite de caracteres
    const limitCharacters = input.dataset.limitCharacters;

    // Criação do elemento contador de caracteres
    const spanContainer = document.createElement('span');
    const counter = document.createElement('strong');
    spanContainer.classList.add('pull-right');
    spanContainer.innerText = 'Caracteres restantes: ';
    spanContainer.appendChild(counter);

    // Adiciona o contador abaixo do input
    input.parentElement.appendChild(spanContainer);

    // Função que bloqueia o limite de caracteres no input
    // e atualiza o contador
    const limitText = () => {
      if (input.value.length > limitCharacters) {
        input.value = input.value.substring(0, limitCharacters);
      } else {
        counter.innerText = limitCharacters - input.value.length;
      }
    }

    // Chamada para ajustar o input no tamanho maximo e o contador
    limitText();

    input.addEventListener('keydown', limitText);
    input.addEventListener('keyup', limitText);
  });
}

exports.init = LimitInputCharacters;
